import { render, staticRenderFns } from "./RootNotFound.vue?vue&type=template&id=df3545c0"
import script from "./RootNotFound.vue?vue&type=script&lang=js"
export * from "./RootNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports